export default "__VITE_ASSET__BUSLtFVq__"